<template>
  <div class="header-fixed" :class="{ 'collapsed': collapsed }">
    <div>
      <a-icon class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="$emit('toggleCollapsed')" />
    </div>
    <div>
      <a-popover title="消息通知" :overlayStyle="{ 'height': '60vh', 'overflow-y': 'scroll', 'overflow-x': 'hidden' }">
        <template slot="content">
          <div class="noticeList" v-for="(val, index) in messageList" :key="index" @click="onTxt(val)">
            <div class="noticeCon" :style="val.is_read === 'yes' ? '' : 'font-weight: bold'">
              <span><a-badge v-if="val.is_read === null || val.is_read === 'no'" color="black" text="black" />{{
                val.publisher }}</span>
              <span class="txt">{{ val.title }}</span>
            </div>
          </div>
        </template>
        <a-badge :count="infoAccount" style="margin-right: 24px;">
          <a-icon style="font-size: 28px" type="bell" />
        </a-badge>
      </a-popover>

      <a-modal :title="info.title" :visible="visible" @ok="visible = false" @cancel="visible = false">
        <div class="noticeCon" style="display: block">
          <p>{{ info.details }}</p>
          <p class="txt" style="width: 100%">{{ info.pub_time }}</p>
        </div>
      </a-modal>

      <a-dropdown :trigger="['click']">
        <span class="trigger">
          {{ displayUsername }}
          <a-icon type="down" />
        </span>
        <a-menu slot="overlay">
          <a-menu-item @click="$router.push('/user/set_password')">
            <span>修改密码</span>
          </a-menu-item>
          <a-menu-divider />
          <a-menu-item @click="logout">
            <span>退出登录</span>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie';
import { noticeRead } from "@/api/user";
import request1 from '@/utils/request1';
export default {
  name: 'Headbar',
  props: ['collapsed', 'username'],
  inject: ['reloadPage'],
  data() {
    return {
      infoAccount: 0,
      info: {},
      visible: false,
      timer: null,
      messageList: [],
      warehouseItems: [],
      currentWarehouse: '所有仓库',
    };
  },
  computed: {
    displayUsername() {
      return this.username || localStorage.getItem("username") || "用户";
    }
  },
  methods: {
    fetchMessages() {
      request1({ url: '/excel/MessageNotifyApi', method: 'get' }).then(res => {
        const list = (res && res.data) || res || [];
        this.messageList = Array.isArray(list) ? list : [];
        this.infoAccount = this.messageList.filter(item => item.is_read === 'no' || item.is_read === null).length;
      }).catch(() => {});
    },
    initData() {
      this.fetchMessages();
      this.timer = setInterval(() => { this.fetchMessages(); }, 60000);
    },
    logout() {
      Cookies.remove('access');
      Cookies.remove('refresh');
      localStorage.removeItem('username');
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.$router.push('/user/login');
    },
    onChangeWarehouse(item) {
      this.currentWarehouse = item.name;
      this.$store.commit('setWarehouse', item.id);
      this.reloadPage();
    },
    onTxt(val) {
      if (val.is_read === null || val.is_read === 'no') {
        noticeRead({ notice_id: val.id })
          .then(() => {
            this.infoAccount -= 1
            val.is_read = 'yes'
          })
          .catch(() => {
            this.$message.error('请求出错');
          });
      }
      this.visible = true
      this.info = val
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  created() {
    this.initData();
  },
}
</script>

<style scoped lang="less">
::v-deep .ant-modal-wrap {
  z-index: 999999;
}

.header-fixed {
  position: fixed;
  top: 0;
  right: 0;
  left: 256px;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.1s cubic-bezier(0.2, 0, 0, 1);
  /* 更平滑的过渡效果 */
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
}

/* 当侧边栏折叠时应用的样式 */
.header-fixed.collapsed {
  left: 80px;
}

/* 修改内部元素的样式，使用flex布局替代float */
.header-fixed>div:first-child {
  padding-left: 16px;
}

.header-fixed>div:last-child {
  display: flex;
  align-items: center;
  padding-right: 16px;
}

.noticeList {
  width: 600px;
  font-size: 16px;
  cursor: pointer;
  padding: 10px 0 20px;
  border-bottom: 1px solid #ddd;
}

.noticeCon {
  display: flex;
  justify-content: space-between;
  font-size: 14px;

  .txt {
    width: 40%;
    text-align: right;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}

.trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

.trigger:hover {
  color: #1890ff;
}
</style>